<template>
  <div class="go-service udesk-go-service-main">
    <i class="iconfont-ot-website">&#xe69b;</i>
    <span class="text">在线客服</span>
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  mounted() {
    this.initUdDesk();
  },
  methods: {
    initUdDesk() {
      //eslint-disable-next-line
      (function (a, h, c, b, f, g) {
        a["UdeskApiObject"] = f;
        a[f] = a[f] || function () { (a[f].d = a[f].d || []).push(arguments) };
        g = h.createElement(c);
        g.async = 1;
        g.charset = "utf-8";
        g.src = b; c = h.getElementsByTagName(c)[0];
        c.parentNode.insertBefore(g, c)
      })(window, document, "script", "https://assets-cli.udesk.cn/im_client/js/udeskApi.js", "ud");
      //eslint-disable-next-line
      ud({
        "code": "3408c8af",
        "link": "https://ibaiqiu.udesk.cn/im_client/?web_plugin_id=1770201",
        targetSelector: '.udesk-go-service-main',
        selector: '.udesk-go-service'
      });
    }
  }
}
</script>

<style lang='scss' scoped>
.go-service {
  position: fixed;
  bottom: 100px;
  right: 20px;
  background-color: #212322;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  display: flex !important;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  cursor: pointer;
  z-index: 9999;
  gap: 2px;
  transition: all .3s ease-in-out;

  &.udesk-go-service-main:after {
    border-radius: 50%;
    box-sizing: content-box;
    content: "";
    height: 100%;
    pointer-events: none;
    position: absolute;
    width: 100%
  }

  &::after {
    opacity: 0;
    padding: 2px;
    box-shadow: 0 0 0 2px #000;
    top: -2px;
    transform: scale(.3);
    transition: transform .4s ease 0s, opacity .4s ease 0s;
    z-index: -1;
    left: -2px
  }

  &:hover {
    transition: all .3s ease-in-out
  }

  &:hover.udesk-go-service-main:after {
    opacity: 1;
    z-index: 1;
    transform: scale(1);
  }


  .iconfont-ot-website {
    font-size: 20px;
    color: #fff;

  }

  .text {
    color: #fff;
    font-size: 9px;
  }
}

@media only screen and (max-width: 1200px) {
  .go-service {
    bottom: 90px;
    width: 40px;
    height: 40px;

    .iconfont-ot-website {
      font-size: 14px;
    }

    .text {
      font-size: 7px;
    }
  }
}
</style>